<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      id="Vector"
      d="M3 20.4598C3 20.7569 3.24555 21 3.54567 21C3.84579 21 4.09134 20.7569 4.09134 20.4598C4.09134 17.1184 6.3204 14.1093 9.52622 13.0802C10.2656 13.4124 11.0814 13.6042 11.9463 13.6042C12.8112 13.6042 13.6351 13.4124 14.3745 13.0748C17.5749 14.0904 19.8012 17.1022 19.8012 20.4571C19.8012 20.7542 20.0467 20.9973 20.3469 20.9973C20.647 20.9973 20.8925 20.7542 20.8925 20.4571C20.8925 16.9374 18.7399 13.7528 15.5504 12.3644C16.92 11.3001 17.804 9.6524 17.804 7.7994C17.8068 4.60392 15.1766 2 11.9463 2C8.7159 2 6.08577 4.60392 6.08577 7.8021C6.08577 9.65781 6.97521 11.3109 8.3503 12.3725C5.1554 13.769 3 16.951 3 20.4598ZM7.17711 7.8021C7.17711 5.19818 9.31613 3.08047 11.9463 3.08047C14.5764 3.08047 16.7154 5.19818 16.7154 7.8021C16.7154 10.406 14.5764 12.5237 11.9463 12.5237C9.31613 12.5237 7.17711 10.406 7.17711 7.8021Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
